import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import cartServices from './cartServices';
import { joinRoom } from '../../../utils/JoinRoom';
import { handleErrorToast } from '../../../utils/handleErrorToast';

export const UserCartCreation = createAsyncThunk(
  'user_cart/create_cart',
  async (payload, thunkAPI) => {
    try {
      let response = await cartServices.cartCreation(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserMajorCartCreation = createAsyncThunk(
  'user_cart/create_major_cart',
  async (payload, thunkAPI) => {
    try {
      let response = await cartServices.cartCreation(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const UserGetCart = createAsyncThunk(
//   'user_cart/get_cart',
//   async (_, thunkAPI) => {
//     try {
//       let response = await cartServices.getCart();

//       return response;
//     } catch (error) {
//       toast(error.message);
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const UserGetCart = createAsyncThunk(
  'user_cart/get_cart',
  async (_, thunkAPI) => {
    try {
      let response = await cartServices.getCart();
      return response;
    } catch (error) {
      handleErrorToast(error, {
        suppressMessages: ['please login or create account'],
        suppressStatusCodes: [401], // optional for token-related issues
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserGetSingleCart = createAsyncThunk(
  'user_cart/get_single_cart',
  async (payload, thunkAPI) => {
    try {
      let response = await cartServices.getSingleCart(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserClearCart = createAsyncThunk(
  'user_cart/clear_cart',
  async (payload, thunkAPI) => {
    try {
      let response = await cartServices.clearCart(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserRemoveCart = createAsyncThunk(
  'user_cart/remove_cart',
  async (payload, thunkAPI) => {
    try {
      let response = await cartServices.removeCart(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const Checkout = createAsyncThunk(
  'user_cart/checkout',
  async (payload, thunkAPI) => {
    try {
      const {
        id,
        socket,
        profile,
        cartProducts,
        dispatch,
        updateCurrentRoom,
        updateSelectedRoom,
        current_room,
        totalPrice,
        symbol,
        navigate,
      } = payload;

      let response = await cartServices.checkout({ id });

      const room_payload = {
        name: profile?.name,
        email: profile?.email,
        phone_number: profile?.phone_number,
        picture: '',
        roomOwner: profile?._id,
        createdBy: profile?._id,
        order_title: `${profile?.name}-${response?.data?._id}`,
        order_id: response?.data?._id,
        room: `${response?.data?._id}-${response?.data?.createdBy}-admin`,
        products: cartProducts,
        totalPrice,
        symbol,
      };

      await socket.emit('create-user', room_payload);

      navigate('/user_dashboard/chat');

      await joinRoom({
        socket,
        room: `${response?.data?._id}-${response?.data?.createdBy}-admin`,
        profile,
        cartProducts,
        dispatch,
        updateCurrentRoom,
        updateSelectedRoom,
        current_room,
        title: `${profile?.name}-${response?.data?._id}`,
        totalPrice,
        symbol,
      });

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
